const replaceNaN = (replacement, original) => (Number.isNaN(original) ? replacement : original);

// noinspection JSUnusedGlobalSymbols
export default replaceNaN;
